const getEntityOrganizationName = (entity) => {
  if (!entity || typeof entity !== 'object') return '';

  const directName =
    entity.sub_organization_name ??
    entity.organization_name ??
    entity.organizationName ??
    entity.org_name ??
    entity.orgName ??
    entity.main_organization_name;
  if (typeof directName === 'string' && directName.trim() !== '') {
    return directName.trim();
  }

  const nestedName = entity.organization?.name;
  if (typeof nestedName === 'string' && nestedName.trim() !== '') {
    return nestedName.trim();
  }

  return '';
};

export const getDeviceDropdownId = (device) => device?._row_id ?? device?.id ?? null;

export const getDeviceDropdownDid = (device) => device?._did ?? device?.did ?? null;

export const formatDropdownLabelWithOrganization = (name, organizationName) => {
  const baseName = String(name ?? '').trim();
  const orgName = String(organizationName ?? '').trim();

  if (!baseName) return orgName;
  if (!orgName) return baseName;

  return `${baseName} (${orgName})`;
};

export const buildDeviceDropdownOption = (device, valueKey = 'id') => {
  const normalizedId = getDeviceDropdownId(device);
  const normalizedDid = getDeviceDropdownDid(device);
  const normalizedDevice = {
    ...(device || {}),
    id: normalizedId,
    did: normalizedDid,
    organization_name: getEntityOrganizationName(device),
  };
  const baseName = normalizedDevice.name || normalizedDid || 'Device';
  const organizationName = getEntityOrganizationName(normalizedDevice);
  const value =
    valueKey === 'id'
      ? normalizedId
      : valueKey === 'did'
        ? normalizedDid
        : normalizedDevice?.[valueKey];

  return {
    ...normalizedDevice,
    value,
    label: formatDropdownLabelWithOrganization(baseName, organizationName),
    baseLabel: baseName,
    organizationLabel: organizationName,
  };
};

export const buildDashboardDropdownOption = (dashboard, valueKey = 'id') => {
  const baseName = dashboard?.name || 'Dashboard';
  const organizationName = getEntityOrganizationName(dashboard);

  return {
    ...(dashboard || {}),
    value: dashboard?.[valueKey],
    label: formatDropdownLabelWithOrganization(baseName, organizationName),
    baseLabel: baseName,
    organizationLabel: organizationName,
  };
};
